interface HyphenateProps {
  text?: string;
}

const Hyphenate: React.FC<HyphenateProps> = ({ text }) => {
  if (!text) return null;

  const shouldHyphenate = /¤¤/.test(text);
  return shouldHyphenate ? (
    <span className="hyphenate" dangerouslySetInnerHTML={{ __html: text.replace(/¤¤/g, '&shy;') }} />
  ) : (
    <span className="hyphenate">{text}</span>
  );
};

Hyphenate.displayName = 'Hyphenate';

export default Hyphenate;
